module.exports = __webpack_public_path__ + "img/bg-banner.50210ace.png";